<template>
    <div class="login-page">
        <CameraCapture :res_out="getCamRes"></CameraCapture>
    <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
      <div class="container">
        <div class="navbar-wrapper">
          <div class="navbar-toggle">
            <button type="button" class="navbar-toggler">
              <span class="navbar-toggler-bar bar1"></span>
              <span class="navbar-toggler-bar bar2"></span>
              <span class="navbar-toggler-bar bar3"></span>
            </button>
          </div>
          <a class="navbar-brand">Modern-Expo Go Go</a>
        </div>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
          <span class="navbar-toggler-bar navbar-kebab"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navigation">
          <ul class="navbar-nav">
            <!--<li class="nav-item ">
              <a href="#" class="nav-link">
                <i class="nc-icon nc-book-bookmark"></i> Register
              </a>
            </li>-->
          </ul>
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
    <div class="wrapper wrapper-full-page ">
      <div class="full-page section-image" filter-color="black">
        <div
          class="full-page-background"
          :style="{ backgroundImage: 'url(' + require('./../assets/img/bg/modern.jpg') + ')'}" />
        <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
        <div class="content">
          <div class="container-fluid">
            <div class="col-lg-6 col-md-8 ml-auto mr-auto">
              <form class="form" method="" action="">
                <div class="card card-login">
                  <div class="card-header ">
                    <div class="card-header ">
                      <h3 class="header text-center" style="margin-bottom: 0">Повідомити про проблему</h3>
                    </div>
                  </div>
                  <div class="card-body">

                    <!--<div class="form-group">
                        <textarea id="comment" rows="4" class="form-control border-primary" placeholder="Коментар" v-model="comment"></textarea>
                    </div>-->
                    <div style="display: flex; justify-content: center;">
                        <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalCAM" @click="$store.state.active_cam = true">
                            <i style="color: #FFFFFF" class="nc-icon nc-camera-compact"></i> Камера 
                        </button>
                        <input type="file" name="file" id="file" class="inputfile" multiple="multiple" @change="onUploadImg"/>
                        <label id="file_loader" for="file">
                          <a class="btn btn-warning" style="font-size: 1em; color: white"><i class="nc-icon nc-image"></i> Вибрати</a>
                        </label>
                        <!--
                          <button type="button" class="btn btn-warning" @click="images = []; images2 = []" v-if="images.length > 0">
                            <i class="nc-icon nc-box"></i> delete images
                          </button>
                        -->
                    </div>

                    <div style="display: flex; justify-content: center;">
                        <div style="max-width: 15%; position: relative; margin-right: 1%; margin-top: 1%; cursor: pointer;" v-for="(image,index) in images" :key="index" @click="deleteItem(index)">
                          <img v-bind:src="image.data" style="width:100%" />
                        </div>
                    </div>

                  </div>
                  <div class="card-footer ">
                    <a class="btn btn-warning btn-block mb-3" @click="sendComment()" style="color: white">
                        <h4 style="margin:0"><i class="nc-icon nc-cloud-upload-94"></i> Відправити</h4>
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
        
        <footer class="footer footer-black  footer-white ">
          <div class="container-fluid">
            <div class="row">
              <nav class="footer-nav">
                <ul>
                  <li>
                    <a href="https://www.modern-expo.com/" target="_blank">Modern-Expo site</a>
                  </li>
                </ul>
              </nav>
              <div class="credits ml-auto">
              <span class="copyright">
                © made with <i class="fa fa-heart heart"></i> by Modern-Expo IT TEAM
              </span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <div v-show="loading">
      <div class="loader-overlay" id="point-loader" style="position: fixed !important;">
        <div
          style="height:100%;
                  display:flex;
                  justify-content: center;
                  align-items:center;">
          <atom-spinner :animation-duration="1000" :size="160" :color="'#ff1d5e'"/>
        </div>
      </div>
    </div>
    <notifications group="error" classes="alert alert-danger"/>
    <notifications group="info" classes="alert alert-info"/>
    <notifications group="success" classes="alert alert-success"/>
  </div>

</template>

<script>
    import CameraCapture from './../components/Camera.vue';
    import {AtomSpinner} from "epic-spinners";

    export default {
        name: "Problem",
        data() {
            return{
                errors: [],
                id: null,
                images: [],
                images2: [],
                comment: '',
                
                filesLimit: 25,

                loading: false,
            }
        },
        methods:{
            onUploadImg(e){
              let tt = null;
              let _this = this;
              var name = null;
              if (e.target.files.length > 0){
                  for (let i = 0; i < e.target.files.length; i++) {
                      const element = e.target.files[i];
                      name = element.name;
                      const reader = new FileReader();
                      reader.readAsDataURL(element);
                      reader.onload = e => {
                        if(this.images.length < this.filesLimit){

                          var filetype = (name).split('.').pop();
                            if( 'jpg png bmp jpeg'.toLowerCase().indexOf(filetype) > -1 ){
                              var img = new Image;
                              img.onload = function() {
                                if(img.width > 1500){
                                  //зжимання
                                  var w = img.width;
                                  var h = img.height;
                                  var canvas = document.createElement('canvas');
                                  var ctx = canvas.getContext('2d'); // Создаем узел атрибута
                                  var anw = document.createAttribute("width"); 
                                  anw.nodeValue = w;
                                  var anh = document.createAttribute("height");
                                  anh.nodeValue = h;
                                  canvas.setAttributeNode(anw);
                                  canvas.setAttributeNode(anh);
                                  ctx.drawImage(img, 0, 0, w, h);
                                  // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                                  var base64Img = canvas.toDataURL('image/jpeg',.6);
                                  //зжимання

                                  tt = (base64Img).split(',');
                                } else {
                                  tt = (img.src).split(',');
                                }

                                _this.images.push({name: _this.id + '_' + (Math.random(100)) + '.png', data: tt[0] + ',' + tt[1] });
                                _this.images2.push({name: _this.id + '_' + (Math.random(100)) + '.png', data: tt[1]});
                              };
                              img.src = e.target.result;
                            } else {
                              tt = (e.target.result).split(',');
                              _this.images.push({name: _this.id + '_' + (Math.random(100)) + name, data: tt[0] + ',' + tt[1] });
                              _this.images2.push({name: _this.id + '_' + (Math.random(100)) + name, data: tt[1]});
                            }
                        } else {
                          this.$notify({ group: 'info', title: 'Warning', text: 'Ліміт файлів ' + this.filesLimit }); 
                        }
                      };                        
                  }
              }
            },
            sendComment(e) {
              let errors = []; 
              let ssParent = this;
              let dataRequest = { 
                id: this.id,
                images: [],
                images2: [],
                comment: null,
              };
              
              if(this.images.length < 1){ errors.push('Прикріпіть фото'); }

              if(errors.length < 1){
                //------------------------------------------------------------------------------------------------------

                for (let i = 0; i < this.images.length; i++) {
                  if(dataRequest.images.length < 5){
                    dataRequest.images.push(this.images[i]);
                    dataRequest.images2.push(this.images2[i]);
                  } else {
                    break
                  }
                }

                getOne();//first run

                function getOne(){
                  ssParent.makeQuery("/draw/addImageQuality",{dataRequest : dataRequest})
                  .then(result => {

                    let lenDR = dataRequest.images.length;
                    dataRequest.images = [];
                    dataRequest.images2 = [];
                    ssParent.images = ssParent.images.splice(lenDR);
                    ssParent.images2 = ssParent.images2.splice(lenDR);

                    if (ssParent.images.length > 0){
                      for (let i = 0; i < ssParent.images.length; i++) {
                        if(dataRequest.images.length < 5){
                          dataRequest.images.push(ssParent.images[i]);
                          dataRequest.images2.push(ssParent.images2[i]);
                        } else {
                          break
                        }
                      }
                      
                      if(dataRequest.images.length > 0){ getOne(); }

                    } else {
                      ssParent.$notify({ group: 'success', title: 'Success ' + ssParent.serial, text: 'Files uploaded!' });
                      ssParent.images = [];
                      ssParent.images2 = [];
                      ssParent.serial = null;
                    }

                  });
                }
                //------------------------------------------------------------------------------------------------------

              } else if(errors.length != 0){
                for (let i = 0; i < errors.length; i++) {
                  this.$notify({ group: 'error', title: 'Warning', text: errors[i] });
                }
              } 

            },
            getCamRes(dataCam){
                //this.images.push(dataCam);
                if (this.isValid(dataCam)){
                    this.images.push({name: this.id + '_' + (this.images.length + 1) + '.png', data: dataCam/*.split(',')[1]*/});
                    this.images2.push({name: this.id + '_' + (this.images.length + 1) + '.png', data: dataCam.split(',')[1]});
                }
            },
            deleteItem(index){
              //remove item
              this.images.splice(index, 1);
              this.images2.splice(index, 1);
            }
        },
        computed: {},
        components: {
            CameraCapture,
            AtomSpinner,
        },
        created(){},
        mounted(){},
        created(){
            console.log(this.$route.params);
            let df = document.location.search;
            if ((this.$route.params.serial != null)||(this.$route.params.serial != undefined)){
                this.id = this.$route.params.serial;
            } else if ((df != '')&&(this.$route.params.serial == undefined)){//якщо кирилиця
                this.id = df;
            }

            if(this.id == null || this.id == undefined || this.id == ''){
                this.$router.push({ name: 'login'});
            }
        },
    }
</script>

<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
#file_loader {
    margin: 0px 0px 0px 1%;
    padding: 0px 0px 0px 0px;
	cursor: pointer;
}
</style> 


// WEBPACK FOOTER //
// src/pages/Quality.vue